// Sistema padronizado de carrinho para Templates Poderosos
class CarrinhoManager {
  constructor() {
    this.uploadModalRef = null
    this.uploadModalPromise = null
    this.init()
  }

  init() {
    // Adicionar estilos CSS para feedback
    this.addFeedbackStyles()
  }

  shouldRequireArtworkUpload(options = {}) {
    if (options.skipUploadModal) return false
    if (options.forceSkipUpload) return false
    return true
  }

  isAllowedArtworkFilename(filename) {
    if (!filename) return false
    const nome = String(filename).toLowerCase().trim()
    return ['.pdf', '.cdr', '.ai', '.psd'].some((ext) => nome.endsWith(ext))
  }

  ensureArtworkUploadModal() {
    if (this.uploadModalRef) return this.uploadModalRef

    const styleId = 'onlytag-artwork-upload-modal-style'
    if (!document.getElementById(styleId)) {
      const style = document.createElement('style')
      style.id = styleId
      style.textContent = `
        .onlytag-upload-modal[hidden] { display: none; }
        .onlytag-upload-modal {
          position: fixed;
          inset: 0;
          z-index: 99999;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 20px;
        }
        .onlytag-upload-modal__backdrop {
          position: absolute;
          inset: 0;
          background: rgba(20, 20, 20, 0.62);
        }
        .onlytag-upload-modal__card {
          position: relative;
          z-index: 1;
          width: min(520px, 100%);
          background: #fff;
          border-radius: 16px;
          padding: 26px 22px 20px;
          box-shadow: 0 20px 48px rgba(0, 0, 0, 0.32);
        }
        .onlytag-upload-modal__close {
          position: absolute;
          top: 10px;
          right: 10px;
          width: 30px;
          height: 30px;
          border: 0;
          border-radius: 999px;
          background: #f2f2f2;
          color: #1f1f1f;
          font-size: 20px;
          line-height: 1;
          cursor: pointer;
        }
        .onlytag-upload-modal__title {
          margin: 0 0 8px;
          color: #1f1f1f;
          font-family: Poppins, sans-serif;
          font-size: 22px;
          font-weight: 700;
          line-height: 1.2;
        }
        .onlytag-upload-modal__desc {
          margin: 0 0 14px;
          color: #444;
          font-family: Poppins, sans-serif;
          font-size: 14px;
          line-height: 1.4;
        }
        .onlytag-upload-modal__label {
          display: block;
          margin: 0 0 8px;
          color: #1f1f1f;
          font-family: Poppins, sans-serif;
          font-size: 14px;
          font-weight: 600;
        }
        .onlytag-upload-modal__input {
          position: absolute;
          opacity: 0;
          pointer-events: none;
          width: 1px;
          height: 1px;
          overflow: hidden;
        }
        .onlytag-upload-modal__picker {
          display: flex;
          align-items: center;
          gap: 12px;
          width: 100%;
          border: 1px solid #ddd;
          border-radius: 12px;
          padding: 10px 12px;
          background: #fafafa;
          cursor: pointer;
          transition: border-color .2s ease, background-color .2s ease;
          margin-bottom: 8px;
        }
        .onlytag-upload-modal__picker:hover {
          border-color: #c3c3c3;
          background: #f7f7f7;
        }
        .onlytag-upload-modal__picker-btn {
          flex-shrink: 0;
          border-radius: 999px;
          background: #620f26;
          color: #fff;
          padding: 8px 12px;
          font-family: Poppins, sans-serif;
          font-size: 12px;
          font-weight: 600;
          line-height: 1;
        }
        .onlytag-upload-modal__picker-text {
          color: #4a4a4a;
          font-family: Poppins, sans-serif;
          font-size: 13px;
          line-height: 1.3;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .onlytag-upload-modal__error {
          min-height: 18px;
          margin: 0 0 16px;
          color: #c62828;
          font-family: Poppins, sans-serif;
          font-size: 12px;
        }
        .onlytag-upload-modal__actions {
          display: flex;
          gap: 10px;
          justify-content: flex-end;
        }
        .onlytag-upload-modal__btn {
          border: 0;
          border-radius: 10px;
          padding: 10px 14px;
          font-family: Poppins, sans-serif;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
        }
        .onlytag-upload-modal__btn--cancel {
          background: #efefef;
          color: #2a2a2a;
        }
        .onlytag-upload-modal__btn--confirm {
          background: #620f26;
          color: #fff;
        }
      `
      document.head.appendChild(style)
    }

    const modal = document.createElement('div')
    modal.className = 'onlytag-upload-modal'
    modal.id = 'onlytag-upload-modal'
    modal.hidden = true
    modal.innerHTML = `
      <div class="onlytag-upload-modal__backdrop" data-upload-modal-close></div>
      <div class="onlytag-upload-modal__card" role="dialog" aria-modal="true" aria-labelledby="onlytag-upload-modal-title">
        <button type="button" class="onlytag-upload-modal__close" data-upload-modal-close aria-label="Fechar">&times;</button>
        <h3 class="onlytag-upload-modal__title" id="onlytag-upload-modal-title">Envie sua arte para continuar</h3>
        <p class="onlytag-upload-modal__desc">Formatos aceitos: .pdf, .cdr, .ai e .psd</p>
        <label class="onlytag-upload-modal__label" for="onlytag-upload-modal-input">Arquivo da arte</label>
        <input id="onlytag-upload-modal-input" class="onlytag-upload-modal__input" type="file" accept=".pdf,.cdr,.ai,.psd">
        <label class="onlytag-upload-modal__picker" for="onlytag-upload-modal-input">
          <span class="onlytag-upload-modal__picker-btn">Selecionar arquivo</span>
          <span class="onlytag-upload-modal__picker-text" id="onlytag-upload-modal-filename">Nenhum arquivo selecionado</span>
        </label>
        <p class="onlytag-upload-modal__error" id="onlytag-upload-modal-error"></p>
        <div class="onlytag-upload-modal__actions">
          <button type="button" class="onlytag-upload-modal__btn onlytag-upload-modal__btn--cancel" data-upload-modal-close>Cancelar</button>
          <button type="button" class="onlytag-upload-modal__btn onlytag-upload-modal__btn--confirm" id="onlytag-upload-modal-confirm">Adicionar</button>
        </div>
      </div>
    `
    document.body.appendChild(modal)

    this.uploadModalRef = {
      container: modal,
      input: modal.querySelector('#onlytag-upload-modal-input'),
      filename: modal.querySelector('#onlytag-upload-modal-filename'),
      error: modal.querySelector('#onlytag-upload-modal-error'),
      confirm: modal.querySelector('#onlytag-upload-modal-confirm'),
      closeElements: modal.querySelectorAll('[data-upload-modal-close]')
    }

    return this.uploadModalRef
  }

  requestArtworkFile() {
    const modal = this.ensureArtworkUploadModal()
    const { container, input, filename, error, confirm, closeElements } = modal

    if (this.uploadModalPromise) return this.uploadModalPromise

    this.uploadModalPromise = new Promise((resolve) => {
      let fechado = false
      const previousOverflow = document.body.style.overflow

      const close = (file = null) => {
        if (fechado) return
        fechado = true
        container.hidden = true
        document.body.style.overflow = previousOverflow
        this.uploadModalPromise = null
        if (input) input.removeEventListener('change', onInputChange)
        closeElements.forEach((el) => el.removeEventListener('click', onCancel))
        confirm.removeEventListener('click', onConfirm)
        document.removeEventListener('keydown', onKeydown)
        resolve(file)
      }

      const onCancel = () => close(null)
      const onKeydown = (event) => {
        if (event.key === 'Escape') close(null)
      }

      const onConfirm = () => {
        if (!input || !input.files || input.files.length === 0) {
          if (error) error.textContent = 'Selecione um arquivo para continuar.'
          return
        }

        const file = input.files[0]
        if (!this.isAllowedArtworkFilename(file.name)) {
          if (error) error.textContent = 'Formato inválido. Use .pdf, .cdr, .ai ou .psd.'
          return
        }

        close(file)
      }

      const onInputChange = () => {
        if (!filename) return
        const file = input && input.files && input.files[0] ? input.files[0] : null
        filename.textContent = file ? file.name : 'Nenhum arquivo selecionado'
        if (error) error.textContent = ''
      }

      if (input) input.value = ''
      if (filename) filename.textContent = 'Nenhum arquivo selecionado'
      if (error) error.textContent = ''
      container.hidden = false
      document.body.style.overflow = 'hidden'
      setTimeout(() => {
        if (input) input.focus()
      }, 10)

      closeElements.forEach((el) => el.addEventListener('click', onCancel))
      confirm.addEventListener('click', onConfirm)
      if (input) input.addEventListener('change', onInputChange)
      document.addEventListener('keydown', onKeydown)
    })

    return this.uploadModalPromise
  }

  // Adicionar produto ao carrinho com loading global
  async addToCart(variantId, quantity = 1, buttonElement = null, customPrice = null, customUnitPrice = null, options = {}) {
    try {
      const normalizedOptions = (options && typeof options === 'object') ? options : {}
      if (this.shouldRequireArtworkUpload(normalizedOptions)) {
        const file = await this.requestArtworkFile()
        if (!file) {
          this.showAlert('Upload cancelado. Selecione o arquivo para adicionar ao carrinho.', 'negativo')
          return null
        }

        return this.addToCart(
          variantId,
          quantity,
          buttonElement,
          customPrice,
          customUnitPrice,
          {
            ...normalizedOptions,
            skipUploadModal: true,
            artworkFile: file
          }
        )
      }

      // Validar quantidade
      const quantityNum = parseInt(quantity)
      if (isNaN(quantityNum) || quantityNum <= 0) {
        throw new Error('Quantidade inválida.')
      }

      const normalizarValorMonetario = (valor) => {
        if (valor === null || valor === undefined) return null
        if (typeof valor === 'number') {
          return Number.isFinite(valor) ? valor : null
        }

        const texto = String(valor).trim()
        if (!texto) return null

        const textoNumerico = texto.replace(/[^\d,.-]/g, '')
        if (!textoNumerico) return null

        const ultimaVirgula = textoNumerico.lastIndexOf(',')
        const ultimoPonto = textoNumerico.lastIndexOf('.')
        let normalizado = textoNumerico

        if (ultimaVirgula > -1 && ultimoPonto > -1) {
          normalizado = ultimaVirgula > ultimoPonto
            ? textoNumerico.replace(/\./g, '').replace(',', '.')
            : textoNumerico.replace(/,/g, '')
        } else if (ultimaVirgula > -1) {
          normalizado = textoNumerico.replace(/\./g, '').replace(',', '.')
        } else {
          normalizado = textoNumerico.replace(/,/g, '')
        }

        const numero = parseFloat(normalizado)
        return Number.isFinite(numero) ? numero : null
      }

      const customPriceNum = normalizarValorMonetario(customPrice)
      const customUnitPriceNum = normalizarValorMonetario(customUnitPrice)
      const hasCustomPrice = Number.isFinite(customPriceNum) && customPriceNum > 0
      const unidadesSolicitadas = quantityNum
      const variantIdInformado = variantId !== null && variantId !== undefined && variantId !== '' && variantId !== 'null' && variantId !== 'undefined'
      // Permitir variantId vazio temporariamente quando houver preço customizado:
      // tentamos resolver pela combinação preço/quantidade do produto atual.
      let variantIdNum = variantIdInformado ? parseInt(variantId, 10) : NaN
      // Para preço customizado, a quantidade comercial vai em propriedade
      // e enviamos 1 item no carrinho para manter checkout consistente.
      let cartQuantity = hasCustomPrice ? 1 : quantityNum

      // Validar consistência de preço entre valor calculado e preço real da variante no Shopify
      // para evitar que o checkout receba itens com valor incorreto (ex.: R$ 0,00).
      if (hasCustomPrice) {
        const precoTotalCalculadoCentavos = Math.round(customPriceNum * 100)
        const draftCheckoutApiUrl = typeof window !== 'undefined' && window.ONLYTAG_DRAFT_CHECKOUT_API_URL
          ? String(window.ONLYTAG_DRAFT_CHECKOUT_API_URL).trim()
          : ''
        const draftCheckoutConfigurado = !!(draftCheckoutApiUrl && !draftCheckoutApiUrl.includes('sua-api.com'))
        const extrairHandleDeTexto = (valor) => {
          if (!valor) return null
          const texto = String(valor)
          const match = texto.match(/\/products\/([^\/?#]+)/i)
          if (!match || !match[1]) return null
          try {
            return decodeURIComponent(match[1])
          } catch (error) {
            return match[1]
          }
        }

        const obterHandleProdutoAtual = () => {
          const handleDoBotao = buttonElement && (
            buttonElement.getAttribute('data-product-handle') ||
            buttonElement.dataset.productHandle
          )
          if (handleDoBotao) return handleDoBotao

          const handleMetaShopify = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product
            ? window.ShopifyAnalytics.meta.product.handle
            : null
          if (handleMetaShopify) return handleMetaShopify

          const handleMetaWindow = window.meta && window.meta.product ? window.meta.product.handle : null
          if (handleMetaWindow) return handleMetaWindow

          const canonicalHref = document.querySelector('link[rel="canonical"]')?.getAttribute('href')
          const handleCanonical = extrairHandleDeTexto(canonicalHref)
          if (handleCanonical) return handleCanonical

          const ogUrl = document.querySelector('meta[property="og:url"]')?.getAttribute('content')
          const handleOgUrl = extrairHandleDeTexto(ogUrl)
          if (handleOgUrl) return handleOgUrl

          const handlePath = extrairHandleDeTexto(window.location.pathname)
          if (handlePath) return handlePath

          return null
        }

        const extrairQuantidadeNumerica = (valor) => {
          if (valor === null || valor === undefined) return null
          const texto = String(valor)
          const match = texto.match(/(\d{1,3}(?:[.\s]\d{3})*|\d+)/)
          if (!match) return null
          const numero = parseInt(match[1].replace(/[.\s]/g, ''), 10)
          return Number.isFinite(numero) ? numero : null
        }

        // Normaliza preço da API: Shopify Ajax retorna em centavos (número); alguns contextos em reais (decimal)
        const precoApiParaCentavos = (valor) => {
          if (valor === null || valor === undefined) return null
          const num = parseFloat(valor)
          if (!Number.isFinite(num)) return null
          if (num <= 0) return null
          // Se o valor parece estar em reais (ex.: 12.90, 129.00), converter para centavos
          if (num > 0 && num < 10000 && num !== Math.floor(num)) {
            return Math.round(num * 100)
          }
          return Math.round(num)
        }

        const avaliarPrecoVariante = (precoVarianteCentavos) => {
          if (!Number.isFinite(precoVarianteCentavos) || precoVarianteCentavos <= 0) {
            return null
          }
          const toleranciaCentavos = 2
          const candidatosQuantidade = new Set([1, quantityNum])
          const razao = precoTotalCalculadoCentavos / precoVarianteCentavos
          ;[Math.floor(razao), Math.round(razao), Math.ceil(razao)].forEach((candidato) => {
            if (Number.isFinite(candidato) && candidato > 0 && candidato <= 100000) {
              candidatosQuantidade.add(parseInt(candidato, 10))
            }
          })

          let melhor = null
          candidatosQuantidade.forEach((cartQuantityCandidata) => {
            if (!Number.isFinite(cartQuantityCandidata) || cartQuantityCandidata <= 0) return
            const totalCandidato = precoVarianteCentavos * cartQuantityCandidata
            const diferencaCentavos = Math.abs(totalCandidato - precoTotalCalculadoCentavos)
            if (!melhor || diferencaCentavos < melhor.diferencaCentavos) {
              melhor = {
                cartQuantity: cartQuantityCandidata,
                diferencaCentavos
              }
            }
          })

          if (melhor && melhor.diferencaCentavos <= toleranciaCentavos) {
            return { cartQuantity: melhor.cartQuantity }
          }

          return null
        }

        const escolherQuantidadeMaisProxima = (precoVarianteCentavos) => {
          if (!Number.isFinite(precoVarianteCentavos) || precoVarianteCentavos <= 0) {
            return 1
          }
          const candidatosQuantidade = new Set([1, quantityNum])
          const razao = precoTotalCalculadoCentavos / precoVarianteCentavos
          ;[Math.floor(razao), Math.round(razao), Math.ceil(razao)].forEach((candidato) => {
            if (Number.isFinite(candidato) && candidato > 0 && candidato <= 100000) {
              candidatosQuantidade.add(parseInt(candidato, 10))
            }
          })

          let melhorQuantidade = 1
          let menorDiferenca = Number.POSITIVE_INFINITY
          candidatosQuantidade.forEach((cartQuantityCandidata) => {
            if (!Number.isFinite(cartQuantityCandidata) || cartQuantityCandidata <= 0) return
            const totalCandidato = precoVarianteCentavos * cartQuantityCandidata
            const diferencaCentavos = Math.abs(totalCandidato - precoTotalCalculadoCentavos)
            if (diferencaCentavos < menorDiferenca) {
              menorDiferenca = diferencaCentavos
              melhorQuantidade = cartQuantityCandidata
            }
          })
          return melhorQuantidade
        }

        const obterPrimeiraVarianteComIdValido = (variants) => {
          if (!Array.isArray(variants)) return null
          for (const variant of variants) {
            const variantId = parseInt(variant && variant.id, 10)
            if (Number.isFinite(variantId) && variantId > 0) {
              return variantId
            }
          }
          return null
        }

        let precoVarianteCentavos = null
        let variantsDoProdutoAtual = []
        if (Number.isFinite(variantIdNum) && variantIdNum > 0) {
          try {
            const variantResponse = await fetch(`/variants/${variantIdNum}.js`, { cache: 'no-store' })
            if (variantResponse.ok) {
              const variantData = await variantResponse.json()
              precoVarianteCentavos = precoApiParaCentavos(variantData && variantData.price)
            }
          } catch (error) {
            console.error('Erro ao validar preço da variante:', error)
          }
        }

        let avaliacao = avaliarPrecoVariante(precoVarianteCentavos)

        // Fallback robusto: se a seção passou variantId ausente/incorreto, tentar localizar
        // uma variante do produto atual que bata com o preço calculado.
        if (!avaliacao) {
          try {
            const productHandle = obterHandleProdutoAtual()

            if (productHandle) {
              const productResponse = await fetch(`/products/${productHandle}.js`, { cache: 'no-store' })
              if (productResponse.ok) {
                const productData = await productResponse.json()
                const variants = Array.isArray(productData && productData.variants) ? productData.variants : []
                variantsDoProdutoAtual = variants

                const candidatos = variants
                  .map((variant) => {
                    const preco = precoApiParaCentavos(variant && variant.price)
                    if (!Number.isFinite(preco) || preco <= 0) return null

                    const avaliacaoLocal = avaliarPrecoVariante(preco)
                    if (!avaliacaoLocal) return null

                    const quantidadeTitulo = extrairQuantidadeNumerica(variant && variant.title)
                    const scoreQuantidade = quantidadeTitulo === quantityNum ? 0 : 1

                    return {
                      variantId: parseInt(variant.id, 10),
                      preco,
                      cartQuantity: avaliacaoLocal.cartQuantity,
                      scoreQuantidade
                    }
                  })
                  .filter(Boolean)
                  .sort((a, b) => {
                    if (a.scoreQuantidade !== b.scoreQuantidade) {
                      return a.scoreQuantidade - b.scoreQuantidade
                    }
                    // Preferir quantity 1 quando ambos forem válidos para reduzir ruído no carrinho
                    if (a.cartQuantity !== b.cartQuantity) {
                      return a.cartQuantity - b.cartQuantity
                    }
                    return a.variantId - b.variantId
                  })

                if (candidatos.length > 0) {
                  const escolhido = candidatos[0]
                  variantIdNum = escolhido.variantId
                  precoVarianteCentavos = escolhido.preco
                  // Para itens com preço customizado, a quantidade técnica deve permanecer 1
                  // para não distorcer o cálculo de frete no checkout.
                  cartQuantity = hasCustomPrice ? 1 : escolhido.cartQuantity
                  avaliacao = { cartQuantity: hasCustomPrice ? 1 : escolhido.cartQuantity }
                  console.warn('Carrinho: variantId ajustado automaticamente para manter consistência de preço:', variantIdNum)
                }
              }
            }
          } catch (error) {
            console.error('Erro ao tentar resolver variante por preço:', error)
          }
        }

        if (!avaliacao) {
          const variantIdEhValido = Number.isFinite(variantIdNum) && variantIdNum > 0
          const precoVarianteEhValido = Number.isFinite(precoVarianteCentavos) && precoVarianteCentavos > 0

          if (!variantIdEhValido || !precoVarianteEhValido) {
            const variantePorQuantidade = variantsDoProdutoAtual
              .map((variant) => {
                const quantidadeTitulo = extrairQuantidadeNumerica(variant && variant.title)
                const preco = precoApiParaCentavos(variant && variant.price)
                return {
                  variantId: parseInt(variant && variant.id, 10),
                  preco,
                  scoreQuantidade: quantidadeTitulo === quantityNum ? 0 : 1
                }
              })
              .filter((item) => Number.isFinite(item.variantId) && item.variantId > 0 && Number.isFinite(item.preco) && item.preco > 0)
              .sort((a, b) => {
                if (a.scoreQuantidade !== b.scoreQuantidade) {
                  return a.scoreQuantidade - b.scoreQuantidade
                }
                return a.variantId - b.variantId
              })[0]

            if (variantePorQuantidade) {
              variantIdNum = variantePorQuantidade.variantId
              precoVarianteCentavos = variantePorQuantidade.preco
            }
          }

          if (Number.isFinite(variantIdNum) && variantIdNum > 0 && Number.isFinite(precoVarianteCentavos) && precoVarianteCentavos > 0) {
            const cartQuantityFallback = escolherQuantidadeMaisProxima(precoVarianteCentavos)
            avaliacao = { cartQuantity: hasCustomPrice ? 1 : cartQuantityFallback }
            console.warn('Carrinho: não foi possível validar compatibilidade exata de preço; mantendo variantId para não bloquear adição ao carrinho.', {
              variantId: variantIdNum,
              cartQuantity: hasCustomPrice ? 1 : cartQuantityFallback,
              precoCalculadoCentavos: precoTotalCalculadoCentavos,
              precoVarianteCentavos
            })
          } else if (draftCheckoutConfigurado) {
            const variantIdFallback = variantIdEhValido
              ? variantIdNum
              : obterPrimeiraVarianteComIdValido(variantsDoProdutoAtual)

            if (Number.isFinite(variantIdFallback) && variantIdFallback > 0) {
              variantIdNum = variantIdFallback
              avaliacao = { cartQuantity: 1 }
              console.warn('Carrinho: variante sem preço válido aceita porque o Draft Checkout está configurado; o total final será garantido pela API.', {
                variantId: variantIdNum,
                precoCalculadoCentavos: precoTotalCalculadoCentavos
              })
            } else {
              console.error('Carrinho: preço calculado (centavos):', precoTotalCalculadoCentavos, 'variantId informado:', variantIdNum, 'preço variante obtido:', precoVarianteCentavos, 'quantidade:', quantityNum)
              throw new Error(
                'Não foi possível localizar uma variante técnica para este produto. Reconfigure e tente novamente.'
              )
            }
          } else {
            console.error('Carrinho: preço calculado (centavos):', precoTotalCalculadoCentavos, 'variantId informado:', variantIdNum, 'preço variante obtido:', precoVarianteCentavos, 'quantidade:', quantityNum)
            throw new Error(
              'Não foi possível localizar uma variante com preço válido para este produto. Cadastre preço nas variantes ou configure o Draft Checkout e tente novamente.'
            )
          }
        }

        cartQuantity = hasCustomPrice ? 1 : avaliacao.cartQuantity
      }

      if (!Number.isFinite(variantIdNum) || variantIdNum <= 0) {
        if (variantIdInformado) {
          throw new Error('ID da variante inválido. Por favor, recarregue a página e tente novamente.')
        }
        throw new Error('Variante do produto não encontrada. Por favor, selecione todas as opções do produto.')
      }

      // Mostrar loading no botão se fornecido
      if (buttonElement) {
        this.showLoading(buttonElement)
      }

      // Verificar se o produto já está no carrinho
      let cartData
      try {
        const cartResponse = await fetch('/cart.js')
        if (!cartResponse.ok) {
          throw new Error('Erro ao acessar o carrinho')
        }
        cartData = await cartResponse.json()
      } catch (error) {
        console.error('Erro ao buscar carrinho:', error)
        // Continuar mesmo se não conseguir verificar o carrinho
        cartData = { items: [] }
      }

      // Verificar se o produto já existe no carrinho com a mesma variante
      const itemsComMesmaVariante = cartData.items.filter((item) => item.variant_id.toString() === variantIdNum.toString())

      // Coletar configurações do produto (tags de configuração)
      const configuracoes = []

      // Função auxiliar para coletar texto de um elemento
      const coletarTexto = (elemento, seletor) => {
        if (!elemento) return null
        const textoEl = elemento.querySelector(seletor)
        if (textoEl) {
          const texto = textoEl.textContent.trim()
          return texto || null
        }
        return null
      }

      // SEMPRE coletar diretamente das opções ativas (método mais confiável)
      // Formato - IMPORTANTE: deve ser a primeira configuração
      let formatoColetado = false
      const formatoAtivo = document.querySelector('.opcao-item[data-opcao^="formato-"].ativo') ||
                         document.querySelector('.opcao-item-adesivo[data-opcao^="formato-"].ativo')
      if (formatoAtivo) {
        // Tentar primeiro o seletor específico do tema2, depois os genéricos
        const textoFormato = coletarTexto(formatoAtivo, '.opcao-texto-formato-adesivo') ||
                            coletarTexto(formatoAtivo, '.opcao-texto') ||
                            coletarTexto(formatoAtivo, '.opcao-texto-adesivo')
        if (textoFormato) {
          const textoLimpo = textoFormato.split('\n')[0].trim()
          if (textoLimpo) {
            // Adicionar formato como PRIMEIRA configuração
            configuracoes.unshift(textoLimpo)
            formatoColetado = true
            console.log('Carrinho: Formato coletado das opções ativas:', textoLimpo)
          }
        } else {
          console.warn('Carrinho: Formato ativo encontrado mas texto não encontrado:', formatoAtivo)
        }
      } else {
        console.log('Carrinho: Nenhum formato ativo encontrado nas opções ativas, tentando resumo...')
      }

      // Se não coletou formato das opções ativas, tentar coletar do resumo ANTES de continuar
      if (!formatoColetado) {
        // Cobre todos os temas de produto: -adesivo, -adesivo-hotstamping, -lacre, etc.
        const tagsContainer = document.querySelector('[id^="resumo-tags-configuracao"]')
        if (tagsContainer) {
          const tags = tagsContainer.querySelectorAll('.resumo-tag, .resumo-tag-adesivo, span')
          // Procurar formato no resumo (geralmente é o primeiro item ou tem padrão "X x Y cm")
          for (let tag of tags) {
            const texto = tag.textContent.trim()
            if (texto && /^\d+[\s,.]*\d*\s*x\s*\d+[\s,.]*\d*\s*cm$/i.test(texto)) {
              configuracoes.unshift(texto)
              formatoColetado = true
              console.log('Carrinho: Formato coletado do resumo:', texto)
              break
            }
          }
        }
      }

      // Impressão
      const impressaoAtiva = document.querySelector('.opcao-item[data-opcao^="impressao-"].ativo') ||
                             document.querySelector('.opcao-item-adesivo[data-opcao^="impressao-"].ativo')
      if (impressaoAtiva) {
        const textoImpressao = coletarTexto(impressaoAtiva, '.opcao-texto') ||
                              coletarTexto(impressaoAtiva, '.opcao-texto-adesivo')
        if (textoImpressao) {
          const textoLimpo = textoImpressao.trim()
          if (textoLimpo) configuracoes.push(textoLimpo)
        }
      }

      // Papel
      const papelAtivo = document.querySelector('.opcao-item[data-opcao^="papel-"].ativo') ||
                        document.querySelector('.opcao-item-adesivo[data-opcao^="papel-"].ativo')
      if (papelAtivo) {
        const textoPapel = coletarTexto(papelAtivo, '.opcao-texto') ||
                          coletarTexto(papelAtivo, '.opcao-texto-adesivo')
        if (textoPapel) {
          const textoLimpo = textoPapel.trim()
          if (textoLimpo) configuracoes.push(textoLimpo)
        }
      }

      // Enobrecimento (coletar primeiro, pois no tema2 pode usar data-opcao="acabamento-furo-*")
      // No tema2, a seção "Enobrecimento" pode usar data-opcao="acabamento-furo-*"
      let enobrecimentoAtivo = document.querySelector('.opcao-item[data-opcao^="enobrecimento-"].ativo') ||
                                document.querySelector('.opcao-item-adesivo[data-opcao^="enobrecimento-"].ativo')

      // Se não encontrou, procurar na seção de Enobrecimento do tema2
      if (!enobrecimentoAtivo) {
        const secaoEnobrecimento = Array.from(document.querySelectorAll('.configuracao-secao-adesivo')).find(secao => {
          const titulo = secao.querySelector('.secao-titulo-adesivo')
          return titulo && titulo.textContent.trim() === 'Enobrecimento'
        })
        if (secaoEnobrecimento) {
          enobrecimentoAtivo = secaoEnobrecimento.querySelector('.opcao-item-adesivo.ativo')
        }
      }

      let textoEnobrecimento = null
      if (enobrecimentoAtivo) {
        textoEnobrecimento = coletarTexto(enobrecimentoAtivo, '.opcao-texto') ||
                           coletarTexto(enobrecimentoAtivo, '.opcao-texto-adesivo')
        if (textoEnobrecimento) {
          const textoLimpo = textoEnobrecimento.trim()
          if (textoLimpo) {
            configuracoes.push(textoLimpo)
            console.log('Carrinho: Enobrecimento coletado:', textoLimpo)
          }
        }
      }

      // Acabamento (apenas se não for da seção de Enobrecimento)
      // No tema2, não coletar acabamento se já coletamos enobrecimento da mesma seção
      const acabamentoAtivo = document.querySelector('.opcao-item[data-opcao^="acabamento-"].ativo') ||
                             document.querySelector('.opcao-item-adesivo[data-opcao^="acabamento-"].ativo')
      if (acabamentoAtivo) {
        // Verificar se este acabamento não é da seção de Enobrecimento
        const secaoAcabamento = acabamentoAtivo.closest('.configuracao-secao-adesivo')
        const ehEnobrecimento = secaoAcabamento && secaoAcabamento.querySelector('.secao-titulo-adesivo') &&
                                secaoAcabamento.querySelector('.secao-titulo-adesivo').textContent.trim() === 'Enobrecimento'

        // Se não é da seção de Enobrecimento, coletar
        if (!ehEnobrecimento) {
          const textoAcabamento = coletarTexto(acabamentoAtivo, '.opcao-texto') ||
                                 coletarTexto(acabamentoAtivo, '.opcao-texto-adesivo')
          if (textoAcabamento) {
            const textoLimpo = textoAcabamento.trim()
            // Verificar se não é duplicata do enobrecimento já coletado
            if (textoLimpo && textoLimpo !== textoEnobrecimento) {
              configuracoes.push(textoLimpo)
              console.log('Carrinho: Acabamento coletado:', textoLimpo)
            }
          }
        } else {
          console.log('Carrinho: Acabamento ignorado (é da seção Enobrecimento, já coletado)')
        }
      }

      // Extras
      const extrasAtivos = document.querySelectorAll('.opcao-item[data-opcao^="extra-"].ativo, .opcao-item-adesivo[data-opcao^="extra-"].ativo')
      extrasAtivos.forEach(extra => {
        const textoExtra = coletarTexto(extra, '.opcao-texto') ||
                          coletarTexto(extra, '.opcao-texto-adesivo')
        if (textoExtra) {
          const textoLimpo = textoExtra.replace(/\n/g, ' ').trim()
          // Verificar se não é duplicata antes de adicionar
          if (textoLimpo && !configuracoes.some(config => config.toLowerCase().trim() === textoLimpo.toLowerCase().trim())) {
            configuracoes.push(textoLimpo)
          } else if (textoLimpo) {
            console.log('Carrinho: Extra duplicado ignorado:', textoLimpo)
          }
        }
      })

      console.log('Carrinho: Configurações coletadas das opções ativas:', configuracoes)

      // SEMPRE tentar coletar do resumo também (pode ter mais configurações)
      // Isso garante que todas as configurações sejam capturadas, especialmente do tema2
      // Cobre todos os temas de produto: -adesivo, -adesivo-hotstamping, -lacre, etc.
      const tagsContainer = document.querySelector('[id^="resumo-tags-configuracao"]')
      if (tagsContainer) {
        const tags = tagsContainer.querySelectorAll('.resumo-tag, .resumo-tag-adesivo, span')
        const configuracoesDoResumo = []
        tags.forEach(tag => {
          const texto = tag.textContent.trim()
          // Ignorar tags vazias ou que sejam apenas espaços
          if (texto && texto.length > 0 && !texto.match(/^\s*$/)) {
            // Verificar se já não está na lista (evitar duplicatas)
            // Também verificar se não é formato (já foi coletado antes se existir)
            const ehFormato = /^\d+[\s,.]*\d*\s*x\s*\d+[\s,.]*\d*\s*cm$/i.test(texto)
            const jaTemFormato = formatoColetado && configuracoes.some(config => /^\d+[\s,.]*\d*\s*x\s*\d+[\s,.]*\d*\s*cm$/i.test(config))

            // Verificar se já existe na lista de configurações (comparação case-insensitive para evitar duplicatas)
            const jaExiste = configuracoes.some(config => config.toLowerCase().trim() === texto.toLowerCase().trim())
            const jaExisteNoResumo = configuracoesDoResumo.some(config => config.toLowerCase().trim() === texto.toLowerCase().trim())

            if (!jaExiste && !jaExisteNoResumo) {
              // Se é formato e já temos formato, pular
              if (ehFormato && jaTemFormato) {
                console.log('Carrinho: Formato já coletado, ignorando duplicata:', texto)
              } else {
                configuracoesDoResumo.push(texto)
              }
            } else {
              console.log('Carrinho: Configuração duplicada ignorada:', texto)
            }
          }
        })
        // Adicionar configurações do resumo que não foram encontradas nas opções ativas
        if (configuracoesDoResumo.length > 0) {
          console.log('Carrinho: Configurações adicionais coletadas do resumo:', configuracoesDoResumo)
          configuracoes.push(...configuracoesDoResumo)
        }
      }

      // Log final das configurações
      console.log('Carrinho: Total de configurações coletadas:', configuracoes.length, configuracoes)

      // Preparar item para adicionar ao carrinho
      const itemToAdd = {
        id: variantIdNum,
        quantity: cartQuantity
      }

      // Inicializar propriedades
      itemToAdd.properties = {}

      // Adicionar configurações como propriedades
      configuracoes.forEach((config, index) => {
        if (config) {
          itemToAdd.properties[`Configuração ${index + 1}`] = config
        }
      })

      // Se houver preço customizado, adicionar como propriedade (em centavos)
      if (hasCustomPrice) {
        let precoEmReais = customPriceNum
        let precoUnitarioEmReais = customUnitPriceNum

        console.log('Carrinho: Valores RECEBIDOS - Total:', customPrice, 'Unitário:', customUnitPrice, 'Quantidade:', unidadesSolicitadas)
        console.log('Carrinho: Valores PARSED - Total:', precoEmReais, 'Unitário:', precoUnitarioEmReais)

        // Garantir consistência: se temos unitário, usar ele para calcular o total correto
        // Isso garante que o total seja sempre exatamente unitário * quantidade
        if (precoUnitarioEmReais !== null) {
          const precoTotalEsperado = precoUnitarioEmReais * unidadesSolicitadas
          const diferencaPercentual = Math.abs(precoEmReais - precoTotalEsperado) / precoTotalEsperado

          // Se houver diferença significativa (mais de 1%), usar o valor calculado para garantir consistência
          if (diferencaPercentual > 0.01) {
            console.warn('Carrinho: Diferença entre total recebido e esperado:', (diferencaPercentual * 100).toFixed(2) + '%')
            console.warn('Carrinho: Total recebido:', precoEmReais, 'Total esperado (unitário * quantidade):', precoTotalEsperado)
            console.warn('Carrinho: Usando total calculado para garantir consistência')
            precoEmReais = precoTotalEsperado
          }
        }

        const precoEmCentavos = Math.round(precoEmReais * 100)
        console.log('Carrinho: Preço TOTAL FINAL em reais:', precoEmReais, '-> Centavos:', precoEmCentavos)
        itemToAdd.properties['_preco_calculado'] = precoEmCentavos.toString()
        itemToAdd.properties['_quantidade_unidades'] = unidadesSolicitadas.toString()
        itemToAdd.properties['Quantidade'] = `${unidadesSolicitadas} unidades`

        // Se houver preço unitário customizado, também adicionar
        if (precoUnitarioEmReais !== null) {
          const precoUnitarioEmCentavos = Math.round(precoUnitarioEmReais * 100)
          console.log('Carrinho: Preço UNITÁRIO FINAL em reais:', precoUnitarioEmReais, '-> Centavos:', precoUnitarioEmCentavos)
          itemToAdd.properties['_preco_unitario_calculado'] = precoUnitarioEmCentavos.toString()
        }
      }

      console.log('Carrinho: Propriedades que serão enviadas:', JSON.stringify(itemToAdd.properties))

      // Verificar se existe um produto com a mesma variante e as mesmas configurações
      if (itemsComMesmaVariante.length > 0) {
        // Função para normalizar propriedades (remover propriedades internas e ordenar)
        const normalizarPropriedades = (properties) => {
          if (!properties) return {}
          const normalizadas = {}
          // Filtrar apenas propriedades de configuração (ignorar preços internos)
          Object.keys(properties).forEach(key => {
            if (!key.startsWith('_')) {
              normalizadas[key] = properties[key]
            }
          })
          return normalizadas
        }

        // Normalizar propriedades do item a ser adicionado
        const propriedadesAtuais = normalizarPropriedades(itemToAdd.properties)

        // Verificar cada item existente com a mesma variante
        const itemDuplicado = itemsComMesmaVariante.find(itemExistente => {
          const propriedadesExistentes = normalizarPropriedades(itemExistente.properties)

          // Comparar se têm o mesmo número de propriedades de configuração
          const keysAtuais = Object.keys(propriedadesAtuais).sort()
          const keysExistentes = Object.keys(propriedadesExistentes).sort()

          if (keysAtuais.length !== keysExistentes.length) {
            return false // Número diferente de configurações = não é duplicado
          }

          // Comparar cada propriedade
          for (const key of keysAtuais) {
            if (!keysExistentes.includes(key)) {
              return false // Propriedade não existe no item existente
            }
            // Comparar valores (case-insensitive e trim para evitar diferenças de formatação)
            const valorAtual = String(propriedadesAtuais[key]).trim().toLowerCase()
            const valorExistente = String(propriedadesExistentes[key]).trim().toLowerCase()
            if (valorAtual !== valorExistente) {
              return false // Valores diferentes = não é duplicado
            }
          }

          return true // Todas as propriedades são iguais = é duplicado
        })

        if (itemDuplicado) {
          // Produto com a mesma variante e configurações exatas já existe no carrinho
          this.showAlert('Esse produto com a mesma configuração já está no seu carrinho!', 'negativo')
          if (buttonElement) {
            this.hideLoading(buttonElement)
          }
          return
        }
        // Se chegou aqui, significa que é o mesmo produto mas com configurações diferentes
        // Permitir adicionar
      }

      const artworkFile = normalizedOptions.artworkFile || null
      let response

      // Fazer requisição para adicionar ao carrinho
      if (artworkFile) {
        const formData = new FormData()
        formData.append('id', String(itemToAdd.id))
        formData.append('quantity', String(itemToAdd.quantity))

        Object.entries(itemToAdd.properties || {}).forEach(([key, value]) => {
          if (value === null || value === undefined) return
          const textValue = String(value).trim()
          if (!textValue) return
          formData.append(`properties[${key}]`, textValue)
        })

        formData.append('properties[Arquivo da arte]', artworkFile, artworkFile.name)

        response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
      } else {
        response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: [itemToAdd]
          })
        })
      }

      // Verificar resposta
      if (!response.ok) {
        let errorMessage = 'Erro ao adicionar produto ao carrinho'

        try {
          const errorData = await response.json()
          if (errorData.description) {
            errorMessage = errorData.description
          } else if (errorData.message) {
            errorMessage = errorData.message
          }

          // Se a mensagem mencionar quantidade limitada, personalizar
          if (errorMessage.toLowerCase().includes('somente') ||
              errorMessage.toLowerCase().includes('disponibilidade') ||
              errorMessage.toLowerCase().includes('availability')) {
            errorMessage = `Nossa produção é sob demanda e não há limitação de quantidade. A quantidade solicitada (${unidadesSolicitadas} unidades) deve ser adicionada ao carrinho. Por favor, verifique a configuração do produto no sistema ou entre em contato conosco.`
          }
        } catch (e) {
          // Se não conseguir parsear o erro, usar mensagem padrão
          errorMessage = `Erro ${response.status}: ${response.statusText}`
        }

        throw new Error(errorMessage)
      }

      const data = await response.json()

      // Verificar se a resposta contém erros
      if (data.errors && Object.keys(data.errors).length > 0) {
        const errorMessages = Object.values(data.errors).flat()
        let errorMsg = errorMessages.join(', ') || 'Erro ao adicionar produto ao carrinho'

        // Se o erro mencionar disponibilidade/estoque, personalizar mensagem
        if (errorMsg.toLowerCase().includes('disponibilidade') ||
            errorMsg.toLowerCase().includes('availability') ||
            errorMsg.toLowerCase().includes('estoque') ||
            errorMsg.toLowerCase().includes('stock') ||
            errorMsg.toLowerCase().includes('somente')) {
          errorMsg = 'Nossa produção é sob demanda. Por favor, verifique se o produto está configurado corretamente no sistema ou entre em contato conosco.'
        }

        throw new Error(errorMsg)
      }

      // Verificar se a quantidade adicionada foi menor que a solicitada (limitação de estoque)
      // Para produção sob demanda, isso não deveria acontecer
      const quantidadeAdicionada = (() => {
        if (data && data.items && Array.isArray(data.items) && data.items[0] && data.items[0].quantity) {
          return parseInt(data.items[0].quantity, 10)
        }
        if (data && data.quantity) {
          return parseInt(data.quantity, 10)
        }
        return null
      })()

      if (Number.isFinite(quantidadeAdicionada) && quantidadeAdicionada < cartQuantity) {
        // Se a quantidade adicionada for menor, informar o usuário
        const mensagem = `Apenas ${quantidadeAdicionada} unidade(s) foram adicionadas ao carrinho. Nossa produção é sob demanda. Por favor, verifique a configuração do produto ou entre em contato conosco para adicionar a quantidade desejada de ${unidadesSolicitadas} unidades.`
        this.showAlert(mensagem, 'negativo')
        console.warn(`Quantidade comercial solicitada: ${cartQuantity}, unidades solicitadas: ${unidadesSolicitadas}, quantidade adicionada: ${quantidadeAdicionada}`)
      }

      // Atualizar contador do carrinho
      try {
        await this.updateCartCount()
      } catch (error) {
        console.error('Erro ao atualizar contador:', error)
        // Não bloquear o fluxo se falhar ao atualizar contador
      }

      // Disparar evento personalizado para atualizar o nav
      document.dispatchEvent(new CustomEvent('cart:updated'))

      // Mostrar feedback de sucesso
      this.showAlert('Produto adicionado ao carrinho!', 'positivo')

      // Abrir o popup do carrinho automaticamente
      this.abrirCarrinho()

      // Remover loading
      if (buttonElement) {
        setTimeout(() => {
          this.hideLoading(buttonElement)
        }, 1000)
      }

      return data
    } catch (error) {
      console.error('Erro ao adicionar ao carrinho:', error)

      // Mostrar mensagem de erro mais específica
      // Verificar se a mensagem é sobre limitação de estoque e personalizar
      let errorMessage = error.message || 'Erro ao adicionar produto ao carrinho!'

      // Se a mensagem mencionar disponibilidade/estoque, informar que é produção sob demanda
      if (errorMessage.toLowerCase().includes('disponibilidade') ||
          errorMessage.toLowerCase().includes('availability') ||
          errorMessage.toLowerCase().includes('estoque') ||
          errorMessage.toLowerCase().includes('stock')) {
        errorMessage = 'Nossa produção é sob demanda. Por favor, entre em contato conosco se houver alguma limitação na quantidade desejada.'
      }

      this.showAlert(errorMessage, 'negativo')

      // Remover loading em caso de erro
      if (buttonElement) {
        this.hideLoading(buttonElement)
      }

      // Não fazer throw para não quebrar o fluxo
      return null
    }
  }

  // Atualizar contador do carrinho
  async updateCartCount() {
    try {
      const response = await fetch('/cart.js')
      const cart = await response.json()

      // Usar items.length para contar produtos únicos, não item_count que conta quantidade total
      const produtosUnicos = cart.items ? cart.items.length : 0

      // Atualizar elementos do carrinho na página
      const carrinhoButtons = document.querySelectorAll('nav .botoes .padrao')
      carrinhoButtons.forEach((button) => {
        if (button.textContent.includes('templates')) {
          button.innerHTML = `
            <img src="/assets/icone-carrinho.svg" alt="Carrinho">
            ${produtosUnicos} templates
          `
        }
      })

      // Atualizar contador se existir elemento específico
      const cartCount = document.getElementById('cart-count')
      if (cartCount) {
        cartCount.textContent = produtosUnicos
      }

      // Atualizar contadorCarrinho também (usado no nav.liquid)
      const contadorCarrinho = document.getElementById('contadorCarrinho')
      if (contadorCarrinho) {
        contadorCarrinho.textContent = produtosUnicos
      }

      return cart
    } catch (error) {
      console.error('Erro ao atualizar contador:', error)
    }
  }

  // Sistema de alertas integrado
  showAlert(mensagem, tipo = 'positivo', duracao = 4000) {
    if (window.mostrarAlerta) {
      window.mostrarAlerta(mensagem, tipo, duracao)
    } else {
      // Fallback caso o alerta.liquid não esteja carregado
      console.log(`Alerta ${tipo}: ${mensagem}`)
    }
  }

  // Abrir popup do carrinho
  abrirCarrinho() {
    // Neste projeto, após adicionar deve sempre ir para a página de carrinho.
    window.location.href = '/cart'
  }

  // Mostrar loading no botão
  showLoading(buttonElement) {
    if (buttonElement) {
      buttonElement.classList.add('loading')
      buttonElement.disabled = true
    }
  }

  // Esconder loading do botão
  hideLoading(buttonElement) {
    if (buttonElement) {
      buttonElement.classList.remove('loading')
      buttonElement.disabled = false
    }
  }


  // Ir para página do produto
  goToProduct(productUrl) {
    if (productUrl && productUrl !== '#') {
      window.location.href = productUrl
    }
  }

  // Adicionar estilos CSS apenas para loading
  addFeedbackStyles() {
    if (document.getElementById('carrinho-loading-styles')) return

    const style = document.createElement('style')
    style.id = 'carrinho-loading-styles'
    style.textContent = `
      /* Loading estados */
      .loading {
        position: relative;
        pointer-events: none !important;
      }

      .loading .icone img {
        animation: spin 1s linear infinite !important;
      }

      .loading::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.1);
        border-radius: inherit;
        animation: pulse 1s infinite;
      }

      /* Animações */
      @keyframes spin {
        from {
          transform: rotate(0deg);
        }
        to {
          transform: rotate(360deg);
        }
      }

      @keyframes pulse {
        0%, 100% {
          opacity: 0.3;
        }
        50% {
          opacity: 0.6;
        }
      }
    `

    document.head.appendChild(style)
  }
}

// Instanciar o gerenciador do carrinho
const carrinho = new CarrinhoManager()

// Funções globais para compatibilidade
window.addToCart = (variantId, quantity = 1, buttonElement = null, customPrice = null, customUnitPrice = null, options = {}) => {
  return carrinho.addToCart(variantId, quantity, buttonElement, customPrice, customUnitPrice, options)
}

window.goToProduct = (productUrl) => {
  return carrinho.goToProduct(productUrl)
}

// Exportar para uso em módulos
if (typeof module !== 'undefined' && module.exports) {
  module.exports = CarrinhoManager
}
